var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: _vm.persistent, width: "fit-content" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "pa-6" }),
          _c("v-divider", { staticClass: "ma-0 mb-0" }),
          _c(
            "v-card-text",
            { staticClass: "pa-12" },
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.insertForeignAgentForDestination"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("label.name"),
                                  rules: _vm.required,
                                },
                                model: {
                                  value: _vm.agent.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "name", $$v)
                                  },
                                  expression: "agent.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("label.sapCode"),
                                  rules: _vm.required,
                                },
                                model: {
                                  value: _vm.agent.sapCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "sapCode", $$v)
                                  },
                                  expression: "agent.sapCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("label.country"),
                                  rules: _vm.required,
                                },
                                model: {
                                  value: _vm.agent.country,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "country", $$v)
                                  },
                                  expression: "agent.country",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("label.destination"),
                                  rules: _vm.required,
                                },
                                model: {
                                  value: _vm.agent.destination,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.agent, "destination", $$v)
                                  },
                                  expression: "agent.destination",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { staticClass: "ma-0 mt-0" }),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-end pa-3" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "success",
                  attrs: { small: "" },
                  on: { click: _vm.submit },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("label.save")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }